export const form = {
  email: {
    label: 'Email',
    placeholder: 'Enter email address'
  },
  name: {
    label: 'First Name',
    placeholder: 'Enter your first name'
  },
  clubName: {
    label: 'Club Name',
    placeholder: 'Enter club name',
    description: 'Enter the name in Latin characters'
  },
  address: {
    label: 'Address',
    placeholder: 'Enter address'
  },
  workPeriod: {
    start: {
      placeholder: 'Start work at'
    },
    end: {
      placeholder: 'Finish work at'
    }
  },
  workTime: {
    start: {
      label: 'Opening Time'
    },
    end: {
      label: 'Closing Time'
    }
  },
  country: {
    label: 'Specify the club location',
    placeholder: 'Specify the club location'
  },
  role: {
    label: 'Club Vacancies'
  },
  currency: {
    label: 'Specify the currency for artist payments',
    placeholder: 'Specify the currency for artist payments'
  },
  nativeLanguage: {
    label: 'Native Language',
    placeholder: 'Specify your native language'
  },
  lastName: {
    label: 'Last Name',
    placeholder: 'Enter your last name'
  },
  birth: {
    label: 'Date of Birth',
    placeholder: 'Enter your date of birth'
  },
  password: {
    label: 'Password',
    placeholder: 'Enter password',
    description:
      'The password must contain at least 8 characters including uppercase and lowercase letters, digits, and special characters (e.g., !, @, #, $)'
  },
  resetPassword: {
    new: {
      label: 'New Password',
      placeholder: 'Enter new password'
    },
    confirm: {
      label: 'Confirm Password',
      placeholder: 'Enter new password'
    }
  },
  penalties: {
    placeholder: 'Enter penalty name'
  },
  phone: {
    label: 'Phone Number',
    placeholder: '+373-000-00-00'
  },
  buttons: {
    continue: 'Continue',
    login: 'Login',
    send: 'Send',
    cancel: 'Cancel',
    confirm: 'Confirm',
    resend: 'Resend',
    register: 'Register',
    registerRequest: 'Submit Registration Request'
  },
  links: {
    forgotPasswordLink: 'Forgot password?',
    login: 'Log In',
    haveAccount: 'I already have an account',
    privacy: 'User Agreement and Privacy Policy.'
  },
  other: {
    or: 'Or'
  },
  approximateStartDate: { label: 'Estimated Start Date' },
  approximateEndDate: { label: 'Estimated End Date' },
  search: {
    placeholder: 'Search',
    placeholderCitizienship: 'Search by citizenship'
  },
  positionItem: {
    label: 'Enter position'
  },
  paymentFrequency: {
    label: 'Payment Frequency'
  },
  price: {
    label: 'Price'
  },
  priceForArtist: {
    label: 'Amount for Artist'
  },
  artistPercent: {
    label: 'Percentage for Artist'
  }
};
